// AI Generated Test
import { Component, Input } from '@angular/core';

@Component({
    selector: 'seo-information-missing-subheadlines',
    standalone: false,
    template: `
        <h5 translate>There is no sub headlines on this page</h5>
    `,
})
export class SeoInformationMissingSubheadlinesComponent {
    @Input() seo: any;

    count (content: any): number {
        if (Array.isArray(content)) {
            return content.length;
        } else if (content === null || content === undefined) {
            return 0;
        }

        return 1;
    }
}
